/* @flow weak */

'use strict';

const Reflux = require('reflux');
const _ = require('lodash');
const QuestionActions = require('../actions/QuestionActions.jsx');

const QuestionStore = Reflux.createStore({
  listenables: [QuestionActions],

  data: [],

  getInitialState() {
    return this.data;
  },

  onLoad(questions) {
    this.data = questions;
    this.trigger(this.data);
  },

  getRootQuestions() {
    return _.filter(this.data, question => {
      return question.parent_id === null || question.parent_id === 'null';
    });
  },

  getChildQuestions: function (id) {
    return _.filter(this.data, question => {
      return question.parent_id === id;
    });
  },

  getImageKeyedQuestions() {
    return _.filter(this.data, question => {
      return _.get(question, 'metadata.ImageRenderKey');
    });
  },

  getQuestionById(id) {
    return _.find(this.data, _.matchesProperty('id', id));
  },

  getQuestionByName(name) {
    return _.find(this.data, _.matchesProperty('name', name));
  },

  getQuestionsStartingWith(prefix) {
    return _.filter(this.data, question => {
      return _.startsWith(question.name, prefix);
    })
  },

  getQuestionsByMetadataKeyName(keyName) {
    return _.filter(this.data, (question) => {
      return question.metadata && question.metadata[keyName];
    });
  }
});

module.exports = QuestionStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/QuestionStore.jsx